import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { FilterService } from 'src/app/services/filter.service';
import { AppConstants } from '../../app.constants';
import { DateRangeFilterModel } from '../../models/date-range-filter-model';

@Component({
  selector: 'ness-date-range-filter',
  templateUrl: './date-range-filter.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DateRangeFilterComponent implements OnInit {
  @Input() dateFilterVerbiage: string = 'Filter by date range';
  @Input() duration: number = AppConstants.filterDateDurationDays;
  @Input() dateFilterStorageKey: string = null;
  @Input() suppressUI: boolean = false;
  dateRangeFilterModel: DateRangeFilterModel = null;

  constructor(public filterService: FilterService,
    private cdr: ChangeDetectorRef) { }

  get yearRange(): string {
    let currentYear = new Date().getFullYear().toString();
    return `${AppConstants.defaultFilterYearRangeStart}:${currentYear}`;
  }

  ngOnInit() {
    this.filterService.applyDateFilters(this.dateFilterStorageKey, this.duration);
    this.filterService.dateRangeFilterModel.subscribe((dm: DateRangeFilterModel) => {
      if (!!dm) {
        this.dateRangeFilterModel = new DateRangeFilterModel(dm.fieldDivisionID, dm.duration, dm.startDate, dm.endDate);
      } else {
        this.resetToDefaultFilters();
      }
      this.cdr.detectChanges();
    });
  }

  public applyFilters(): void {
    sessionStorage.setItem(this.dateFilterStorageKey, JSON.stringify(this.dateRangeFilterModel));
    this.filterService.applyDateFilters(this.dateFilterStorageKey, this.duration);
  }

  public resetToDefaultFilters(): void {
    this.filterService.resetDatesFilterDefaults(this.duration);
  }
}
